import { ChallengeModel } from "../ChallengeModel";
import { ActionStatus, ActionStatusHelper } from "@/Shared";
import { ChallengeHelper } from "../challenge-helper";

/**
 * Class: ChallengeFormViewModel
 *
 * Description:
 * ViewModel to manage challenge forms in the application.
 * Responsibilities include:
 * - Providing titles and messages for the UI
 * - Wrapping challenge data with helper functions
 * - Exposing status checks for loading, success, failure, and validation
 *
 * Author: Samano CASTRE
 * Date: July 17, 2025
 */
export class ChallengeFormViewModel {
    
    /**
     * =====================================================
     * Constructor
     * =====================================================
     *
     * @param challenge - ChallengeModel instance representing the current user challenge
     */
    public constructor(private challenge: ChallengeModel) { }


    /**
     * =====================================================
     * UI Feedback Messages
     * =====================================================
     *
     * getError - Returns an error message, defaults to a generic string if none provided
     * getSuccess - Returns a success message when the challenge is completed
     */
    getError = (error? : string) => error || "Une erreur s'est produite";
    getSuccess = () => "Brvo, vous être un humain!";


     /**
     * =====================================================
     * Challenge Info
     * =====================================================
     *
     * title - Returns the title to display in the form, including expected digits
     * id - Returns the challenge ID
     */
    get title() {
       return `Saisir le code suivant: ${this.challenge.expectedDigits || ""}`;
    }

    get id() {
        return this.challenge.id;
    }


     /**
     * =====================================================
     * Status Checks
     * =====================================================
     *
     * isBlocked - Returns true if the challenge is blocked
     * hasSucceeded - Returns true if the provided status is succeeded
     * hasFailed - Returns true if the provided status is failed
     * isLoading - Returns true if the provided status is loading
     * isValidated - Returns true if the challenge has been validated
     */
    isBlocked = () => {
        return this.challenge && ChallengeHelper.isBlocked(this.challenge)
    }

    hasSucceeded = (status : ActionStatus) => {
        return ActionStatusHelper.isSucceeded(status)
    }

    hasFailed = (status : ActionStatus) => {
        return ActionStatusHelper.isFailed(status)
    }

    isLoading = (status : ActionStatus) => {
        return ActionStatusHelper.isLoading(status)
    }

    isValidated = () =>  ChallengeHelper.isValidated(this.challenge);

}